// Export without redux connection
import TutorialPage1 from "./TutorialPage1";

export default TutorialPage1;
